/**
 * Data Classification Section
 * PROJ-042 - Data Classification & Canvas Enhancement
 *
 * Complete section for classification in NodePropertiesPanel
 */

import { Shield } from 'lucide-react';
import { CollapsibleSection } from '@/components/ui/collapsible-section';
import { ClassificationSelector } from './ClassificationSelector';
import { ClassificationBadge } from './ClassificationBadge';

interface DataClassificationSectionProps {
  nodeId: string;
  classificationCode: string | null;
  onClassificationChange: (code: string | null) => void;
}

export function DataClassificationSection({
  nodeId,
  classificationCode,
  onClassificationChange
}: DataClassificationSectionProps) {
  return (
    <CollapsibleSection
      id={`${nodeId}-classification`}
      title="Data Classification"
      icon={Shield}
      defaultOpen={false}
      badge={
        classificationCode ? (
          <ClassificationBadge code={classificationCode} />
        ) : null
      }
    >
      <div className="space-y-4">
        <ClassificationSelector
          value={classificationCode}
          onChange={onClassificationChange}
        />
      </div>
    </CollapsibleSection>
  );
}
